import { Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import Layout from './components/Layout/Layout'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Home from './pages/Home/Home'
import Management from './pages/Management/Management'
import InvestorsVds from './pages/InvestorsVds/InvestorsVds'
import Login from './pages/Login/Login'

function App() {
  return (
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>}>
      <Router>
        <ScrollToTop />
        <AuthProvider>
            <Routes>
              {/* The sign-in screen itself is always reachable. */}
              <Route path="/login" element={<Login />} />

              {/* Layout (nav + footer) wraps both audiences. The gate sits on
                  one route inside it, not on the layout, so the shell renders
                  the same either way. */}
              <Route element={<Layout />}>
                {/* Residents. PUBLIC — anyone with the URL reads it, no code.
                    This page is the consumer pitch and nothing on it is
                    commercially sensitive. */}
                <Route path="/" element={<Home />} />

                {/* Property management. Gated: it carries the revenue share,
                    the terms and the returns table, which is what the NDA on
                    the code screen is actually protecting. */}
                <Route
                  path="/management"
                  element={
                    <ProtectedRoute>
                      <Management />
                    </ProtectedRoute>
                  }
                />

                {/* VDS · StackCombo investor brief. Same gate. No audience switch. */}
                <Route
                  path="/investors"
                  element={
                    <ProtectedRoute>
                      <InvestorsVds />
                    </ProtectedRoute>
                  }
                />

                {/* Anything else lands back on the public front page rather
                    than on a blank layout. */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
        </AuthProvider>
      </Router>
    </Suspense>
  )
}

export default App
